import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { FPSAtom } from '@root/shared/lib'
import { useTranslation } from '@root/shared/localization'
import { ReservedSpace } from '@root/shared/ui-kit'

import { fpsToQuality, QUALITY_COLOR_MAP } from './model'

export const StatusBarFps = () => {
  const { t } = useTranslation()
  const [currentFps] = useAtom(FPSAtom.currentAtom)
  const [avgFps] = useAtom(FPSAtom.avgAtom)

  return (
    <Root
      style={{
        '--metrics-color': QUALITY_COLOR_MAP[fpsToQuality(currentFps)],
        '--border-color': 'var(--metrics-color)',
      }}
    >
      <Fps>
        FPS <ReservedSpace $chars={3}>{currentFps ?? '--'}</ReservedSpace>
        {import.meta.env.DEV ? (
          <>
            {' '}
            ({t('common.mean')}{' '}
            <ReservedSpace $chars={3}>{avgFps ?? '--'}</ReservedSpace>)
          </>
        ) : undefined}
      </Fps>
    </Root>
  )
}

const Root = styled.div`
  color: var(--metrics-color);
  background-color: var(--backgroundA-3);
  border-radius: 4px;

  display: grid;
  grid-auto-flow: column;
  align-items: center;
  justify-self: end;

  gap: 4px;
  height: 16px;
  text-transform: capitalize;
  padding-inline: 5px;
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;

  transition: all 0.15s linear;
`

const Fps = styled.span`
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
`
